import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { IProps } from './PreCopyWeblinkDialog';

export const renderPreCopyWeblink = (data: IProps) => openPopupHelper<IProps>({ popupName: popupNames.PRE_COPY_WEBLINK, data });
